var map = {
	"./about-us-banner-cn.webp": 1549,
	"./about-us-banner-m-cn.webp": 1550,
	"./about-us-banner-m-ms.webp": 1551,
	"./about-us-banner-m.webp": 1552,
	"./about-us-banner-ms.webp": 1553,
	"./about-us-banner.webp": 467,
	"./banner-01.jpg": 1554,
	"./banner-slot.jpg": 1555,
	"./bet-and-earn-banner-cn.webp": 1556,
	"./bet-and-earn-banner-indon.webp": 1557,
	"./bet-and-earn-banner-ms.webp": 1558,
	"./bet-and-earn-banner.webp": 1559,
	"./check-in-banner-cn.webp": 1560,
	"./check-in-banner-id.webp": 1561,
	"./check-in-banner-ms.webp": 1562,
	"./check-in-banner.webp": 1563,
	"./cny_2024-bm.webp": 1564,
	"./cny_2024-cn.webp": 1565,
	"./cny_2024.webp": 1566,
	"./epl-banner-cn.webp": 1567,
	"./epl-banner-indo.webp": 1568,
	"./epl-banner-ms.webp": 1569,
	"./epl-banner.webp": 1570,
	"./games-banners-cn.webp": 1571,
	"./games-banners-ms.webp": 1572,
	"./games-banners.webp": 1573,
	"./lb-m-banner-cn.webp": 1574,
	"./lb-m-banner.webp": 1575,
	"./leaderboard-banner-cn.webp": 1576,
	"./leaderboard-banner.webp": 1577,
	"./lottery-banner.webp": 1578,
	"./lottery-banners-cn.webp": 1579,
	"./lottery-banners-ms.webp": 1580,
	"./lottery-banners.webp": 1581,
	"./lucky-spin-banner-cn.webp": 1582,
	"./lucky-spin-banner-ms.webp": 1583,
	"./lucky-spin-banner.webp": 1584,
	"./p2p-banner.webp": 1585,
	"./p2p-banners-cn.webp": 1586,
	"./p2p-banners-ms.webp": 1587,
	"./p2p-banners.webp": 1588,
	"./premier-league-banner-cn.webp": 1589,
	"./premier-league-banner.webp": 1590,
	"./promo-vip-banner-cn.webp": 1591,
	"./promo-vip-banner-ms.webp": 1592,
	"./promo-vip-banner.webp": 1593,
	"./promos-banner-cn.webp": 1594,
	"./promos-banner-indon.webp": 1595,
	"./promos-banner-ms.webp": 1596,
	"./promos-banner.webp": 1597,
	"./promos-detail-banner.jpg": 1598,
	"./side-bar-banner.jpg": 1599,
	"./slot-banners-cn.webp": 1600,
	"./slot-banners-ms.webp": 1601,
	"./slot-banners.webp": 1602,
	"./speed-banners-cn.webp": 1603,
	"./speed-banners-ms.webp": 1604,
	"./speed-banners.webp": 1605,
	"./vip-banner-cn.webp": 1606,
	"./vip-banner-id.webp": 1607,
	"./vip-banner-m-cn.webp": 1608,
	"./vip-banner-m-ms.webp": 1609,
	"./vip-banner-m.webp": 1610,
	"./vip-banner-ms.webp": 1611,
	"./vip-banner.webp": 1612,
	"./vip-deposit-marathon-challenges-cn.webp": 1613,
	"./vip-deposit-marathon-challenges-ms.webp": 1614,
	"./vip-deposit-marathon-challenges.webp": 1615,
	"./winner-leaderboard-banner-cn.webp": 1616,
	"./winner-leaderboard-banner.webp": 1617,
	"./world-cup-banner-cn.webp": 1618,
	"./world-cup-banner.webp": 1619,
	"./world-cup-two-banner-cn.webp": 1620,
	"./world-cup-two-banner.webp": 1621
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;